import { isCivilDate } from '@/features/envelope/envelopeRange';

/**
 * The register's "need allocation" view (TMMAPP-0117 A1): `?unallocated=1&from=…`. tmm-api counts
 * the lines that need allocation from the budget start, with no end, while the register defaults to
 * Year to date; so the link carries the earliest of the given dates as `from` (the register shows it
 * as a Custom range) and every counted line is in view. With no date, the register's default.
 */
export function unallocatedHref(
  accountId: number,
  ...from: ReadonlyArray<string | null | undefined>
): string {
  const earliest = from
    .filter((date): date is string => date != null && isCivilDate(date))
    .sort()[0];
  const params = new URLSearchParams({ unallocated: '1' });
  if (earliest !== undefined) params.set('from', earliest);
  return `/me/accounts/${accountId}?${params.toString()}`;
}
